<multi-device-header [state]="state"></multi-device-header>
<ng-container [ngSwitch]="state">
    <multi-device-what *ngSwitchCase="'what'"></multi-device-what>
    <multi-device-when *ngSwitchCase="'when'"></multi-device-when>
    <multi-device-who *ngSwitchCase="'who'"></multi-device-who>
    <multi-device-how *ngSwitchCase="'how'"></multi-device-how>
    <multi-device-summary *ngSwitchCase="'summary'"></multi-device-summary>
</ng-container>
